import { render, staticRenderFns } from "./ilmoitukset.vue?vue&type=template&id=d5595df8&scoped=true&"
import script from "./ilmoitukset.vue?vue&type=script&lang=ts&"
export * from "./ilmoitukset.vue?vue&type=script&lang=ts&"
import style0 from "./ilmoitukset.vue?vue&type=style&index=0&id=d5595df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5595df8",
  null
  
)

export default component.exports